import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectIsGloballyLoading } from '../../selectors/GlobalLoading'
import '../../css/GlobalLoadingIndicator.scss'

export const GlobalLoadingIndicator = ({ isLoading }) => {
  if (!isLoading) {
    return null
  }

  return (
    <div
      className="global-loading-indicator"
      role="progressbar"
      aria-label="Loading"
      aria-busy="true"
    >
      <div className="global-loading-progress-bar" />
    </div>
  )
}

GlobalLoadingIndicator.propTypes = {
  isLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  isLoading: selectIsGloballyLoading(state)
})

export default connect(mapStateToProps)(GlobalLoadingIndicator)
